/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Bfsg_Vpat_LinkInputs */

const en_about_bfsg_vpat_link = /** @type {(inputs: About_Bfsg_Vpat_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View the VPAT report`)
};

const de_about_bfsg_vpat_link = /** @type {(inputs: About_Bfsg_Vpat_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VPAT-Bericht ansehen`)
};

const fr_about_bfsg_vpat_link = /** @type {(inputs: About_Bfsg_Vpat_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consulter le rapport VPAT`)
};

const es_about_bfsg_vpat_link = /** @type {(inputs: About_Bfsg_Vpat_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver el informe VPAT`)
};

const it_about_bfsg_vpat_link = /** @type {(inputs: About_Bfsg_Vpat_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consulta il rapporto VPAT`)
};

const nl_about_bfsg_vpat_link = /** @type {(inputs: About_Bfsg_Vpat_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bekijk het VPAT-rapport`)
};

const pl_about_bfsg_vpat_link = /** @type {(inputs: About_Bfsg_Vpat_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zobacz raport VPAT`)
};

const fi_about_bfsg_vpat_link = /** @type {(inputs: About_Bfsg_Vpat_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Katso VPAT-raportti`)
};

const da_about_bfsg_vpat_link = /** @type {(inputs: About_Bfsg_Vpat_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se VPAT-rapporten`)
};

const sv_about_bfsg_vpat_link = /** @type {(inputs: About_Bfsg_Vpat_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visa VPAT-rapporten`)
};

/**
* | output |
* | --- |
* | "View the VPAT report" |
*
* @param {About_Bfsg_Vpat_LinkInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const about_bfsg_vpat_link = /** @type {((inputs?: About_Bfsg_Vpat_LinkInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Bfsg_Vpat_LinkInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_about_bfsg_vpat_link(inputs)
	if (locale === "fr") return fr_about_bfsg_vpat_link(inputs)
	if (locale === "es") return es_about_bfsg_vpat_link(inputs)
	if (locale === "it") return it_about_bfsg_vpat_link(inputs)
	if (locale === "nl") return nl_about_bfsg_vpat_link(inputs)
	if (locale === "pl") return pl_about_bfsg_vpat_link(inputs)
	if (locale === "fi") return fi_about_bfsg_vpat_link(inputs)
	if (locale === "da") return da_about_bfsg_vpat_link(inputs)
	if (locale === "sv") return sv_about_bfsg_vpat_link(inputs)
	return en_about_bfsg_vpat_link(inputs)
});